var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list"},[_c('div',{staticClass:"card-list__container container"},_vm._l((_vm.$store.state['item'].items),function(card){return _c('Card',{key:card.id,staticClass:"card-list__card",attrs:{"card":card},on:{"cardPick":function($event){return _vm.pickHandler(card.id)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }